import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=6456da8e&scoped=true"
import script from "./NewsDetail.vue?vue&type=script&lang=js"
export * from "./NewsDetail.vue?vue&type=script&lang=js"
import style0 from "./NewsDetail.vue?vue&type=style&index=0&id=6456da8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6456da8e",
  null
  
)

export default component.exports